import axios from 'axios';
// import dotenv from 'dotenv';

// require('dotenv').config()

export const client = axios.create({
  // baseURL: 'https://145.253.131.243/api',
  // baseURL: process.env.REACT_APP_BASEURL,
  // baseURL: 'https://doctors.ecocarelifestyle.com/api',
  // baseURL: 'https://doctors.dev.ecocarelifestyle.com/api',
  // baseURL: 'https://healthpoint.alpha.ecocare.health/api',
  withCredentials: true,
});

export const loginClient = axios.create({
  // baseURL: 'https://api.dit.ecocarelifestyle.com',
  // withCredentials: true,
});

export const authorizeClient = axios.create({
  // baseURL: 'https://web.dit.ecocarelifestyle.com',
  // withCredentials: true,
});

export const supportClient = axios.create({
  baseURL: process.env.REACT_APP_SUPPORT_API,
});

export const signalingClient = axios.create({
  baseURL: process.env.REACT_APP_SIGNALING_SERVER,
})